import { render, staticRenderFns } from "./ElementDestination.vue?vue&type=template&id=860723a4&"
import script from "./ElementDestination.vue?vue&type=script&lang=js&"
export * from "./ElementDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports